import { render, staticRenderFns } from "./agenda-geral-main.vue?vue&type=template&id=748a9592&"
import script from "./agenda-geral-main.vue?vue&type=script&lang=js&"
export * from "./agenda-geral-main.vue?vue&type=script&lang=js&"
import style0 from "./agenda-geral-main.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports